import React from 'react';
import { Link } from 'react-router-dom';
import PublicNav from './layout/PublicNav';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[var(--theme-bg-primary)] text-text-primary flex flex-col">
      <PublicNav />

      {/* Main Content */}
      <main className="flex-1 pt-[calc(80px+env(safe-area-inset-top,0px))] pb-10">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-border-light bg-bg-secondary">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <span className="text-xl font-bold bg-gradient-to-r from-crimson to-bronze bg-clip-text text-transparent">
                Helm
              </span>
              <p className="text-text-secondary text-sm mt-2">Power exchange, structured.</p>
            </div>
            <div>
              <h4 className="font-semibold text-sm mb-3">Product</h4>
              <div className="flex flex-col gap-2">
                <Link to="/features" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Features</Link>
                <Link to="/pricing" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Pricing</Link>
                <Link to="/blog" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Blog</Link>
                <Link to="/register" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Sign Up</Link>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-sm mb-3">Support</h4>
              <div className="flex flex-col gap-2">
                <Link to="/support" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Help Center</Link>
                <Link to="/help" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Quick Guide</Link>
                <a href="mailto:support@submitlist.space" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Contact Us</a>
              </div>
            </div>
            <div>
              <h4 className="font-semibold text-sm mb-3">Legal</h4>
              <div className="flex flex-col gap-2">
                <Link to="/privacy-policy" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Privacy Policy</Link>
                <Link to="/terms-of-service" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Terms of Service</Link>
                <Link to="/data-deletion" className="text-text-secondary text-sm no-underline hover:text-text-primary transition-colors">Data Deletion</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-border-light">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-4">
            <p className="text-text-secondary text-xs text-center">
              &copy; {new Date().getFullYear()} Helm. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicLayout;
